'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown, SvgChevronup } from '@common/__generated__/icon';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { BREAKPOINTS, DONATION_ROUTES, IMAGE_PLACEHOLDER, WEL_MARKET_ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ProductActions } from './ProductActions';
import type { OrderProductFlat } from './types';
interface ProductCardProps {
  product: OrderProductFlat;
  orderId: string;
  orderNo: string;
  orderType?: string;
  orderStatus?: string;
  orderStatusName?: string;
  onVendorInfoClick?: () => void;
  alwaysExpanded?: boolean;
  deliveryId?: string;
}
export const ProductCard = t0 => {
  const $ = _c(87);
  const {
    product,
    orderId,
    orderNo,
    orderType,
    orderStatus,
    orderStatusName,
    onVendorInfoClick,
    alwaysExpanded: t1,
    deliveryId
  } = t0;
  const alwaysExpanded = t1 === undefined ? false : t1;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  const [isOptionsExpanded, setIsOptionsExpanded] = useState(alwaysExpanded);
  const isPointMarket = orderType === "POINT_MARKET";
  const isGift = orderType === "GIFT";
  let t2;
  if ($[0] !== product.options) {
    t2 = product.options ?? [];
    $[0] = product.options;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const hasOptions = options.length > 0;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("pb-12 font-700 text-Gray-900 typo-body2", "mobile-tablet:pb-8 mobile-tablet:typo-body4");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = product.productStatusName ?? orderStatusName;
  let t5;
  if ($[3] !== t4) {
    t5 = <p className={t3}>{t4}</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("flex flex-col gap-16 pb-16", "mobile-tablet:gap-12 mobile-tablet:pb-12");
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== product.govCodeName) {
    t7 = product.govCodeName && <div className={cn("bg-Gray-200 px-12 py-4 flex-center", "mobile-tablet:px-6 mobile-tablet:py-3")}><span className={cn("font-600 text-Gray-600 typo-body4", "mobile-tablet:typo-caption2")}>{product.govCodeName}</span></div>;
    $[6] = product.govCodeName;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("font-600 text-Gray-600 typo-body3", "mobile-tablet:typo-caption1");
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== product.vendorName) {
    t9 = <p className={t8}>{product.vendorName}</p>;
    $[9] = product.vendorName;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t9) {
    t10 = <div className="flex items-center gap-8">{t7}{t9}</div>;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isDesktop || $[15] !== onVendorInfoClick) {
    t11 = onVendorInfoClick ? <Button theme="sub-line" dimensions={isDesktop ? "H32" : "H26"} onClick={onVendorInfoClick}>판매자 정보</Button> : null;
    $[14] = isDesktop;
    $[15] = onVendorInfoClick;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <div className="flex items-center justify-between">{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("flex items-center justify-between gap-20", "mobile-tablet:justify-start mobile-tablet:gap-8");
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== isPointMarket || $[22] !== orderType || $[23] !== product.productId || $[24] !== product.productImageUrl || $[25] !== product.productName || $[26] !== product.productNumber || $[27] !== product.productType) {
    t14 = isPointMarket ? <div className="flex gap-8"><Image src={product.productImageUrl ?? IMAGE_PLACEHOLDER} alt={"\uC0C1\uD488 \uC774\uBBF8\uC9C0"} width={208} height={208} className={cn("size-104 shrink-0 object-cover", "mobile-tablet:size-72")} /><div className="flex flex-col gap-6"><p className={cn("line-clamp-2 break-keep font-500 text-Gray-900 typo-body2", "mobile-tablet:typo-body4")}>{product.productName}</p><p className={cn("font-400 text-Gray-600 typo-body3", "mobile-tablet:typo-caption1")}>모바일 교환권</p></div></div> : <CustomLink className="flex gap-8" href={orderType === "LOCAL_MARKET" ? WEL_MARKET_ROUTES.PRODUCT_DETAIL.pathname({
      productNumber: product.productId ?? ""
    }) : DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: product.productNumber ?? ""
    })} aria-label={"\uC0C1\uD488 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}><Image src={product.productImageUrl ?? IMAGE_PLACEHOLDER} alt={"\uC0C1\uD488 \uC774\uBBF8\uC9C0"} width={208} height={208} className={cn("size-104 shrink-0 object-cover", "mobile-tablet:size-72")} /><div className="flex flex-col gap-6"><p className={cn("line-clamp-2 break-keep font-500 text-Gray-900 typo-body2", "mobile-tablet:typo-body4")}>{product.productName}</p>{product.productType === "DIGITAL" && <p className={cn("font-400 text-Gray-600 typo-body3", "mobile-tablet:typo-caption1")}>모바일 교환권</p>}</div></CustomLink>;
    $[21] = isPointMarket;
    $[22] = orderType;
    $[23] = product.productId;
    $[24] = product.productImageUrl;
    $[25] = product.productName;
    $[26] = product.productNumber;
    $[27] = product.productType;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = product.productId ?? "";
  const t16 = product.options?.[0]?.orderItemId;
  const t17 = product.productStatus ?? orderStatus;
  const t18 = product.productType === "DIGITAL";
  const t19 = product.options?.[0]?.couponCode;
  let t20;
  if ($[29] !== deliveryId || $[30] !== orderId || $[31] !== orderNo || $[32] !== orderType || $[33] !== product.hasReview || $[34] !== product.returnId || $[35] !== product.trackingProvider || $[36] !== t15 || $[37] !== t16 || $[38] !== t17 || $[39] !== t18 || $[40] !== t19) {
    t20 = <ProductActions className="mobile-tablet:hidden" orderId={orderId} orderNo={orderNo} productId={t15} reviewProductId={t16} orderProductStatus={t17} isOnlineProduct={t18} hasReview={product.hasReview} returnId={product.returnId} orderType={orderType} couponCode={t19} deliveryId={deliveryId} trackingProvider={product.trackingProvider} />;
    $[29] = deliveryId;
    $[30] = orderId;
    $[31] = orderNo;
    $[32] = orderType;
    $[33] = product.hasReview;
    $[34] = product.returnId;
    $[35] = product.trackingProvider;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t14 || $[43] !== t20) {
    t21 = <div className={t13}>{t14}{t20}</div>;
    $[42] = t14;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t12 || $[46] !== t21) {
    t22 = <div className={t6}>{t12}{t21}</div>;
    $[45] = t12;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== hasOptions || $[49] !== isGift || $[50] !== isOptionsExpanded || $[51] !== isPointMarket || $[52] !== options) {
    t23 = hasOptions && !isPointMarket && <div className="grid transition-[grid-template-rows] duration-300 ease-in-out" style={{
      gridTemplateRows: isOptionsExpanded ? "1fr" : "0fr"
    }}><ul className={cn("flex flex-col gap-8 overflow-hidden", "mobile-tablet:gap-6")}>{options.map((option, index) => <li key={index} className={cn("flex flex-col gap-16 bg-Gray-50 p-20", "mobile-tablet:gap-2 mobile-tablet:p-12")}><p className={cn("font-400 text-Gray-600 typo-body3", "mobile-tablet:typo-caption1")}>옵션: {option.optionName}</p><div className="flex items-center justify-between"><p className={cn("font-400 text-Gray-600 typo-body3", "mobile-tablet:typo-caption1")}>수량: {option.quantity}개</p>{!isGift && <p className={cn("font-500 text-Gray-900 typo-body2", "mobile-tablet:typo-body4")}>{(option.subtotal ?? 0).toLocaleString()}원</p>}</div></li>)}</ul></div>;
    $[48] = hasOptions;
    $[49] = isGift;
    $[50] = isOptionsExpanded;
    $[51] = isPointMarket;
    $[52] = options;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== isGift || $[55] !== product.productSubtotal) {
    t24 = !isGift && <div className={cn("flex items-center justify-between p-8 font-600 text-Gray-900 typo-body2", "mobile-tablet:py-4 mobile-tablet:typo-body4")}><span>주문 금액</span><span>{product.productSubtotal?.toLocaleString()}원</span></div>;
    $[54] = isGift;
    $[55] = product.productSubtotal;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== alwaysExpanded || $[58] !== hasOptions || $[59] !== isOptionsExpanded || $[60] !== isPointMarket || $[61] !== options.length) {
    t25 = hasOptions && !alwaysExpanded && !isPointMarket && <button type="button" onClick={() => setIsOptionsExpanded(_temp)} className="bg-white flex h-32 w-full items-center justify-center gap-4 rounded-xsmall"><span className={cn("font-600 text-Gray-600 typo-body3", "mobile-tablet:text-Gray-550 mobile-tablet:typo-caption1")}>총 {options.length}건 주문</span><span className={cn("font-600 text-Gray-600 typo-body3", "mobile-tablet:text-Gray-550 mobile-tablet:typo-caption1")}>{isOptionsExpanded ? "\uC811\uAE30" : "\uD3BC\uCCD0\uBCF4\uAE30"}</span>{isOptionsExpanded ? <SvgChevronup className={cn("size-12 text-Gray-600", "mobile-tablet:text-Gray-550")} /> : <SvgChevrondown className={cn("size-12 text-Gray-600", "mobile-tablet:text-Gray-550")} />}</button>;
    $[57] = alwaysExpanded;
    $[58] = hasOptions;
    $[59] = isOptionsExpanded;
    $[60] = isPointMarket;
    $[61] = options.length;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  const t26 = product.productId ?? "";
  const t27 = product.options?.[0]?.orderItemId;
  const t28 = product.productStatus ?? orderStatus;
  const t29 = product.productType === "DIGITAL";
  const t30 = product.options?.[0]?.couponCode;
  let t31;
  if ($[63] !== deliveryId || $[64] !== orderId || $[65] !== orderNo || $[66] !== orderType || $[67] !== product.hasReview || $[68] !== product.returnId || $[69] !== product.trackingProvider || $[70] !== t26 || $[71] !== t27 || $[72] !== t28 || $[73] !== t29 || $[74] !== t30) {
    t31 = <ProductActions className="hidden mobile-tablet:flex" orderId={orderId} orderNo={orderNo} productId={t26} reviewProductId={t27} orderProductStatus={t28} isOnlineProduct={t29} hasReview={product.hasReview} returnId={product.returnId} orderType={orderType} couponCode={t30} deliveryId={deliveryId} trackingProvider={product.trackingProvider} />;
    $[63] = deliveryId;
    $[64] = orderId;
    $[65] = orderNo;
    $[66] = orderType;
    $[67] = product.hasReview;
    $[68] = product.returnId;
    $[69] = product.trackingProvider;
    $[70] = t26;
    $[71] = t27;
    $[72] = t28;
    $[73] = t29;
    $[74] = t30;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== isPointMarket || $[77] !== product.productType) {
    t32 = product.productType === "DIGITAL" && !isPointMarket && <p className={cn("pt-8 text-right font-400 text-Gray-550 typo-body3", "mobile-tablet:text-center mobile-tablet:font-700 mobile-tablet:typo-caption1")}>* 구매취소는 구매일로부터 30일까지만 가능해요.</p>;
    $[76] = isPointMarket;
    $[77] = product.productType;
    $[78] = t32;
  } else {
    t32 = $[78];
  }
  let t33;
  if ($[79] !== t22 || $[80] !== t23 || $[81] !== t24 || $[82] !== t25 || $[83] !== t31 || $[84] !== t32 || $[85] !== t5) {
    t33 = <li className="flex flex-col">{t5}{t22}{t23}{t24}{t25}{t31}{t32}</li>;
    $[79] = t22;
    $[80] = t23;
    $[81] = t24;
    $[82] = t25;
    $[83] = t31;
    $[84] = t32;
    $[85] = t5;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  return t33;
};
function _temp(prev) {
  return !prev;
}